import { render, staticRenderFns } from "./CredentialPrev.vue?vue&type=template&id=4736b8dc&scoped=true"
import script from "./CredentialPrev.vue?vue&type=script&lang=js"
export * from "./CredentialPrev.vue?vue&type=script&lang=js"
import style0 from "./CredentialPrev.vue?vue&type=style&index=0&id=4736b8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736b8dc",
  null
  
)

export default component.exports